import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { CountryCollectionQuery, CountryCollectionQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(CountryCollectionQuery)
@Wrapper(CountryCollectionQueryHandlerBase)
export class CountryCollectionQueryHandler {
    public constructor(
        http: Http
    ) { }
}
